<template>
    <div class="">
    <div class="row">
      <div class="col-md-9 col-sm-9">
        <div class="card card-default widget animated">
            <div class="card-heading">
                <div class="form-group">
                    <p style="font-size:35px">{{report_info['name']}}</p>
                    
                    <div v-if="this.$route.params.id === '1' || this.$route.params.id === '3' || this.$route.params.id === '6'">
                        <v-select placeholder="User(s)" multiple :options="users" :value.sync="write_users" label="name" name="users"></v-select>
                        </br>
                    </div>
                    <v-select v-if="this.$route.params.id === '3'" placeholder="Sensor" :options="sensors" v-model="write_sensor" label="name" name="users"></v-select>
                    <v-select v-else-if="this.$route.params.id === '1' || this.$route.params.id === '2'" placeholder="Workflow" :options="workflows" v-model="write_workflow" label="name" name="users"></v-select>
                    <v-select v-else-if="this.$route.params.id === '7'" placeholder="DataField" :options="dataFields" v-model="write_datafield" label="name" name="users"></v-select>
                    <v-select v-else-if="this.$route.params.id !== '6'" placeholder="Asset" :options="assets" v-model="write_asset" label="name" name="users"></v-select>

                    <div v-if="this.$route.params.id !== '6' || this.$route.params.id === '7'">
                        </br>
                    </div>

                    <input v-if="this.$route.params.id === '7'" v-model="dataFieldValue" type="text" class="input-sm form-control half" :class="{'input': true, 'is-danger': errors.has('dataFieldValue') }" placeholder="Data Field Value" name="dataFieldValue" />

                    <div v-show="this.$route.params.id !== '7'" class="input-daterange input-group" data-provide="datepicker" id="datepicker">
                        <input type="text" class="input-sm form-control half" id="startDate" :class="{'input': true, 'is-danger': errors.has('date') }" placeholder="Start Date" name="date" readonly/>
                        <span class="input-group-addon form-control half" >to</span>
                        <input type="text" class="input-sm form-control half" id="endDate" :class="{'input': true, 'is-danger': errors.has('date') }" placeholder="End Date" name="date" readonly/>
                    </div>
                    </br>
                    <div v-show="this.$route.params.id !== '7'" class="input-daterange input-group">
                        <input id="starttimeinput" v-on:click="showTimePickerStart=!showTimePickerStart" type="text" class="input-sm form-control half" :class="{'input': true, 'is-danger': errors.has('date') }" placeholder="Start Time" name="date" readonly/>
                        <span class="input-group-addon form-control half" >to</span>
                        <input id="endtimeinput" v-on:click="showTimePickerEnd=!showTimePickerEnd" type="text" class="input-sm form-control half" :class="{'input': true, 'is-danger': errors.has('date') }" placeholder="End Time" name="date" readonly/>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div v-if="this.showTimePickerStart" class="timepicker">
                                <time-picker class="input-sm" v-model="startTime" icon-control-up="fa fa-chevron-up" icon-control-down="fa fa-chevron-down"/>
                            </div>
                        </div>
                        <div class="col">
                            <div v-if="this.showTimePickerEnd" class="timepicker">
                                <time-picker class="input-sm" v-model="endTime" icon-control-up="fa fa-chevron-up" icon-control-down="fa fa-chevron-down"/>
                            </div>
                        </div>
                    </div>               
                </div>
                </br>
                <button type="button" v-on:click="run" class="btn btn-default">Run</button>
                </br>
                </br>
                </br>
                <div v-if="ran">
                    <p v-if="this.$route.params.id === '2'">
                        <b> Note: The  <i>Late at</i>  time is the time when the task(s) were registered as late</b>
                        <br>
                        <br>    
                        <b> Note: The  <i>Should have been completed at</i>  time for each task is the minute after it was due</b>                   
                    </p>
                    <data-table :reportName="report_info['name']" :reportId="this.$route.params.id" :data="tableData" :columns="gridColumns" :tasks="write_workflow.tasks" :ranger="write_workflow['ranger']" :workflow="write_workflow.name" :workflowDescription="write_workflow.description" :asset="write_asset.name" :invUser="write_user" :datafield="write_datafield.name" :end="new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate(), this.endTime.getHours(), this.endTime.getMinutes())" :start="new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate(), this.startTime.getHours(), this.startTime.getMinutes())"></data-table>
                </div>
                <div v-if="loading && ran" class="loading">
                    <StretchLoading></StretchLoading>
                </div>
            </div> 
        </div>
      </div><!-- /.col-md-8 -->
    </div>
  </div>
</template>

<script>
    import Vue from 'vue'
    import database from '../webmaster/Database/database'
    import $ from "jquery"
    import jQuery from 'jQuery'
    window.jQuery = jQuery
    import tether from 'tether'
    window.Tether = 'tether'
    import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
    import '../../../node_modules/bootstrap/dist/css/bootstrap-grid.min.css'
    import '../../../node_modules/bootstrap/dist/css/bootstrap-reboot.min.css'
    import '../../../node_modules/bootstrap/dist/js/bootstrap.min.js'
    import bootstrap from 'bootstrap'

    import '../../../node_modules/font-awesome/css/font-awesome.min.css'
    import '../../../node_modules/font-awesome/fonts/fontawesome-webfont.svg'

    import '../../../node_modules/bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css'
    import '../../../node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js'

    import VueTimepicker from 'vue2-timepicker'

    import { library } from '@fortawesome/fontawesome-svg-core'
    import { faCoffee } from '@fortawesome/free-solid-svg-icons'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

    library.add(faCoffee)

    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    import * as uiv from 'uiv'
    Vue.use(uiv)

    import vSelect from 'vue-select'
    import DataTable from './DataTable'

    import reportsJson from './reports.json'

    import StretchLoading from '../common/StretchLoading.vue'

    export default {
        name: 'dataFilter',
        components:{
            'data-table': DataTable,
            'font-awesome-icon' : FontAwesomeIcon,
            vSelect,
            VueTimepicker,
            StretchLoading,
        },
        data () {
            return {
                startDate: '',
                endDate: '',

                showTimePickerStart: false,
                startTime: new Date(0, 0, 0, 0, 0, 0),
                showTimePickerEnd: false,
                endTime: new Date(0, 0, 0, 23, 59, 59),

                write_workflow: '',
                workflows: [],

                write_user: '',

                write_asset: '',
                assets: [],

                write_datafield: '',
                dataFields: [],
                dataFieldValue: '',

                write_sensor: '',
                sensors: [],

                report_info:[],
                reports: reportsJson,

                user_ids: [],
                users: [],
                write_users: [
                ],

                ran: false,
                tableData: [],
                gridColumns: [],
                gridColumns_export: {
                    'start': "String", 
                    'end': "String",
                    'completed by': "String",},

                loading: true,
                locationTags: [],
            }
        },
        watch: {
            endTime: function(time) {
                document.getElementById('endtimeinput').value = this.date_to_norm_time(time)
                if (document.getElementById('startDate').value == document.getElementById('endDate').value){
                    if (time < this.startTime) {
                        this.startTime = time 
                    }
                }
            },
            startTime: function(time) {
                document.getElementById('starttimeinput').value = this.date_to_norm_time(time)
                if (document.getElementById('startDate').value == document.getElementById('endDate').value){
                    if (time > this.endTime) {
                        this.endTime = time 
                    }
                }
            },
        },
        created:function(){
            this.fetchAll()
        },
        mounted() {
            $.fn.datepicker.defaults.todayBtn = "linked";
            $.fn.datepicker.defaults.todayHighlight = true;
            $('.datepicker').datepicker({
                autoclose: true,
                format: 'mm/dd/yyyy',
                startDate: '-3d',
            });
        },
        methods: {
            fetchAll:function(){
                this.fetchReportInfo()

                //Only fetch users if it is the 1st report
                if (this.$route.params.id === '1' || this.$route.params.id === '3' || this.$route.params.id === '6'){
                    this.fetchUsers()
                }

                //If it is the 3rd report, get sensors and workflows. 
                if (this.$route.params.id === '3') {
                    this.fetchSensors()
                    this.fetchWorkflows()
                } else if (this.$route.params.id === '1' || this.$route.params.id === '2'){
                    this.fetchWorkflows()
                } else if (this.$route.params.id === '7'){
                    this.fetchDataFields()
                    this.fetchAssets()
                } else if (this.$route.params.id !== '6'){
                    this.fetchAssets()
                }
            },
            fetchUsers:function(){
                //Get all users
                var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/users'
                this.$bindAsArray('users', database.getRef(ref));
            },
            fetchAssets:function(){
                //Get all assets
                this.assets = [
                    {
                        ".key": "hi",
                        name: "Mattress",
                        groups: "Bedding",
                        total: 5027,
                        allocated: 4924,
                        instock: 103,
                        location: "C-12"
                    },
                    {
                        ".key": "889526094584",
                        name: "3/32-Inch Drill Bits",
                        groups: "Tools",
                        total: 47,
                        allocated: 8,
                        instock: 39,
                        location: "B-15"
                    },
                    {
                        ".key": "hi2",
                        name: "Hammer",
                        groups: "Tools",
                        total: 84,
                        allocated: 37,
                        instock: 47,
                        location: "A-11"
                    },
                    {
                        ".key": "hi3",
                        name: "T-Shirt",
                        groups: "Clothing",
                        total: 5048,
                        allocated: 4924,
                        instock: 124,
                        location: "D-28"
                    },
                    {
                        ".key": "hi4",
                        name: "Pants",
                        groups: "Clothing",
                        total: 5048,
                        allocated: 4924,
                        instock: 124,
                        location: "D-29"
                    },
                    {
                        ".key": "hi5",
                        name: "Towel",
                        groups: "Hygiene",
                        total: 5134,
                        allocated: 4370,
                        instock: 764,
                        location: "B-04"
                    }
                ];
            },
            fetchDataFields: function() {
                this.dataFields = [{"name":"Price","type":"number",".key":"0FjbA2ZOL3BJRoakB0c9"},{"name":"For Sale","type":"bool",".key":"6Iq4mNeVk9sMJcUvLF0o"},{"name":"Groups","options":{"0LHSU9UmnqsPXzQ5vT5w":"Medicine","ALtxBrGX77YoICHKa1Yq":"Tools","KKqkAOzzxvgbk49ljtmh":"Entertainment","WfK3QL2TVz5qImDX3eR2":"Book","oyDvLSAce4mAgA2g5vYr":"Pain Reliever","spV4liYK2Ib6n1MI5KUZ":"Bedding"},"type":"selector",".key":"6orf3N149UPSpJDrPXDs"},{"name":"Name","required":true,"type":"text",".key":"BsNzKuUbOpA9duKR4mUg"},{"name":"Retire Date","type":"timestamp",".key":"HuvK5wgv0IXQjusf2rm3"},{"name":"Quantity","type":"number",".key":"QH6UO0GcI5H3qxdHLels"},{"name":"Location","type":"text",".key":"ViB5zETGIqN2nt2sU5um"},{"name":"Notes","type":"text",".key":"b0H0OnCNXelSP4zlSGps"},{"name":"Expiration Date","type":"timestamp",".key":"dgoYaO4elNuUxDoobCt2"},{"name":"Usage","type":"text",".key":"lRljdNGrOxmYT84vLn46"},{"name":"Mainenance Date","type":"timestamp",".key":"qfwqOu9HWPeXWudgBIia"},{"name":"Producer","type":"text",".key":"rNODOadlKFj0tgaDe5bh"},{"name":"Checked Out Quantity","type":"number",".key":"rcgd6ZrS3yWlkdo4wrd6"},{"name":"Tool Class","options":{"UZRdF2EMvfJ4KWwH4PvQ":"Class 1","wTX1jKSKMZXfPJrKE8vf":"Class 2","wx3JKE9m7hSnhHbYA0HW":"Class 3"},"type":"selector",".key":"y7vtrGO3xxiiunUGXAgF"}];
                //let orgId = this.$store.state.usermain.curOrg.id;

                //let self = this;
                
                /*let collection = database.getFireStoreColl(
                    "orgs/" + orgId + "/datafields/"
                );

                collection.get().then(function(querySnapshot) {
                    let _dateFields = {};

                    querySnapshot.forEach(doc => {
                        let docData = doc.data()

                        docData['.key'] = doc.id

                        console.log(docData);

                        _dateFields[doc.id] = docData;
                    });

                    console.log()

                    self.dataFields = Object.values(_dateFields);
                }); */
            },
            fetchSensors:function(){
                //Get all sensors
                var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/devices'
                this.$bindAsArray('sensors', database.getRef(ref).orderByChild('type').equalTo('Location Tag'));
            },
            fetchWorkflows:function(){
                //Get all workflows
                var workflowsRef = '/orgs/' + this.$store.state.usermain.curOrg.id + '/meta_workflows'
                switch (this.$route.params.id) {
                    case "3":
                    case "1":
                        //This fetches workflows
                        this.$bindAsArray('workflows', database.getRef(workflowsRef));
                        break;
                    case "2":
                        //This fetches workflows that aren't ranger workflows
                        this.$bindAsArray('workflows', database.getRef(workflowsRef).orderByChild('ranger').equalTo(null));
                        break;
                }
            },
            fetchReportInfo:function() {
                this.report_info = this.reports[(parseInt(this.$route.params.id) - 1)]                
            },
            date_to_norm_time: function(_date){
                var date = _date;
                var hours= date.getHours();
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? 'pm' : 'am';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0'+minutes : minutes;
                var time = hours + ':' + minutes + ' ' + ampm;
                return time
            },
            getLocationTagById: function(id) {
                for(var tag in this.locationTags){
                    if(this.locationTags[tag]['.key']==id) {
                        return this.locationTags[tag];
                    }
                }
            },
            run:function(){
                this.tableData.length = 0;
                var start = new Date(document.getElementById('startDate').value);
                this.startDate = start
                var startOfDay = new Date(start.getFullYear(), start.getMonth(), start.getDate(), this.startTime.getHours(), this.startTime.getMinutes());
                var starttimestamp = startOfDay / 1000;

                var end = new Date(document.getElementById('endDate').value);
                this.endDate = end
                var endOfDay = new Date(end.getFullYear(), end.getMonth(), end.getDate(), this.endTime.getHours(), this.endTime.getMinutes());
                var endtimestamp = endOfDay / 1000;

                for (var key in this.write_users) {
                    if (this.write_users.hasOwnProperty(key)) {
                        this.user_ids.push(this.write_users[key]['.key'])
                    }
                }
                                
                switch (this.$route.params.id) {
                    case "1":
                        this.gridColumns = ['start', 'end', 'completed by', 'late reason']
                        this.$bindAsArray('tableData', database.getRef('/orgs/' + this.$store.state.usermain.curOrg.id + '/workflows/' + this.write_workflow['.key'] + '/completions/').orderByKey().startAt(String(starttimestamp)).endAt(String(endtimestamp)), null, () => {
                            var arrlength = this.tableData.length;
                            if (this.user_ids.length != 0){
                                for (var i = 0; i < arrlength; i++) {
                                    var index = this.tableData.indexOf(this.tableData[i])
                                    if (index > -1) {
                                        if (this.user_ids.indexOf(this.tableData[index]['completed_by']) <= -1) {
                                            delete this.tableData[index]
                                        }
                                    }
                                }
                                this.tableData = this.tableData.filter( Boolean );
                            }

                            this.loading = false
                            this.user_ids = []
                        });
                        break;
                    case "2":
                        this.gridColumns = ['late at', 'should have been completed at']
                        this.$bindAsArray('tableData', database.getRef('/orgs/' + this.$store.state.usermain.curOrg.id + '/workflows/' + this.write_workflow['.key'] + '/noncompletions/').orderByKey().startAt(String(starttimestamp)).endAt(String(endtimestamp)), null, () => {
                            this.loading = false
                            this.user_ids = []
                        });
                        break;
                    case "3":
                        this.gridColumns = ['task', 'time', 'workflow', 'completed by', 'note', 'attributes']

                        var self = this

                        var user_ids = this.user_ids

                        this.workflows.forEach(function (workflow, workflowIndex) {
                            if (workflow["tasks"] != null) {
                                workflow["tasks"].forEach(function (task, taskIndex) {
                                    if (task["locationtag"] != null) {
                                        if (task["locationtag"]["id"] == self.write_sensor['.key']) {
                                            database.getRef('/orgs/' + self.$store.state.usermain.curOrg.id + '/workflows/' + workflow['.key'] + '/completions/').orderByKey().startAt(String(starttimestamp)).endAt(String(endtimestamp)).once('value').then(workflowCompletions => {
                                                if (workflowCompletions.val() != null){
                                                    var arrlength = Object.keys(workflowCompletions.val()).length;

                                                            //workflowCompletions.val() = workflowCompletions.val().filter( Boolean );

                                                    for (var completion in workflowCompletions.val()) {
                                                        if (user_ids.length != 0){
                                                            if (user_ids.indexOf(workflowCompletions.val()[completion]['completed_by']) != -1) {
                                                                var completionAddition = {}
                                                                completionAddition["time"] = workflowCompletions.val()[completion]["tasks"][taskIndex]["time"]
                                                                completionAddition["note"] = workflowCompletions.val()[completion]["tasks"][taskIndex]["note"]   
                                                                completionAddition["attributes"] = workflowCompletions.val()[completion]["tasks"][taskIndex]["attributes"]     
                                                                completionAddition["name"] = task["locationtag"]["description"]
                                                                completionAddition["workflow_name"] = workflow["name"]
                                                                completionAddition["completed_by"] = workflowCompletions.val()[completion]["completed_by"]

                                                                self.tableData = self.tableData.concat(completionAddition)
                                                            }
                                                        } else {
                                                            var completionAddition = {}
                                                            completionAddition["time"] = workflowCompletions.val()[completion]["tasks"][taskIndex]["time"]
                                                            completionAddition["note"] = workflowCompletions.val()[completion]["tasks"][taskIndex]["note"]   
                                                            completionAddition["attributes"] = workflowCompletions.val()[completion]["tasks"][taskIndex]["attributes"]     
                                                            completionAddition["name"] = task["locationtag"]["description"]
                                                            completionAddition["workflow_name"] = workflow["name"]
                                                            completionAddition["completed_by"] = workflowCompletions.val()[completion]["completed_by"]

                                                            self.tableData = self.tableData.concat(completionAddition)
                                                        }
                                                    }
                                                }

                                                self.loading = false
                                                self.user_ids = []
                                            })
                                        }
                                    }
                                })
                            } else if (workflow["ranger"] == true) {
                                self.$bindAsArray('locationTags', database.getRef('/orgs/' + self.$store.state.usermain.curOrg.id + '/devices').orderByChild('type').equalTo("Location Tag"))

                                database.getRef('/orgs/' + self.$store.state.usermain.curOrg.id + '/workflows/' + workflow['.key'] + '/completions/').orderByKey().startAt(String(starttimestamp)).endAt(String(endtimestamp)).once('value').then(workflowCompletions => {
                                    if (workflowCompletions.val() != null){
                                        var arrlength = Object.keys(workflowCompletions.val()).length;

                                        //workflowCompletions.val() = workflowCompletions.val().filter( Boolean );
                                        for (var completion in workflowCompletions.val()) {
                                            if (user_ids.length != 0){
                                                if (user_ids.indexOf(workflowCompletions.val()[completion]['completed_by']) != -1) {
                                                    for (var task in workflowCompletions.val()[completion]["tasks"]) {
                                                        if (workflowCompletions.val()[completion]["tasks"][task]["id"] == self.write_sensor['.key']) {
                                                            var completionAddition = {}
                                                            completionAddition["time"] = workflowCompletions.val()[completion]["tasks"][task]["time"]
                                                            completionAddition["note"] = workflowCompletions.val()[completion]["tasks"][task]["note"]   
                                                            completionAddition["attributes"] = workflowCompletions.val()[completion]["tasks"][task]["attributes"]     
                                                            completionAddition["name"] = self.getLocationTagById(workflowCompletions.val()[completion]["tasks"][task]["id"])["name"]
                                                            completionAddition["workflow_name"] = workflow["name"]
                                                            completionAddition["completed_by"] = workflowCompletions.val()[completion]["completed_by"]

                                                            self.tableData = self.tableData.concat(completionAddition)
                                                        }
                                                    }
                                                }
                                            } else {
                                                for (var task in workflowCompletions.val()[completion]["tasks"]) {
                                                    if (workflowCompletions.val()[completion]["tasks"][task]["id"] == self.write_sensor['.key']) {
                                                        var completionAddition = {}
                                                        completionAddition["time"] = workflowCompletions.val()[completion]["tasks"][task]["time"]
                                                        completionAddition["note"] = workflowCompletions.val()[completion]["tasks"][task]["note"]   
                                                        completionAddition["attributes"] = workflowCompletions.val()[completion]["tasks"][task]["attributes"]     
                                                        completionAddition["name"] = self.getLocationTagById(workflowCompletions.val()[completion]["tasks"][task]["id"])["name"]
                                                        completionAddition["workflow_name"] = workflow["name"]
                                                        completionAddition["completed_by"] = workflowCompletions.val()[completion]["completed_by"]

                                                        self.tableData = self.tableData.concat(completionAddition)
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    self.loading = false
                                    self.user_ids = []
                                })
                            }
                        });
                        break;
                    
                    case "4":
                        this.gridColumns = ['completed by', 'date time', 'incident', 'reason']

                        this.tableData = [
                            {
                                "completed_by":"Brian Johnson",
                                "time":"6/1/2019 at 5:42 pm",
                                "incident":"Lost",
                                "reason":"I went to the bathroom, came back it was gone",
                            },
                            {
                                "completed_by":"David Smith",
                                "time":"6/1/2019 at 2:46 pm",
                                "incident":"Lost",
                                "reason":"Don't remember where I left it",
                            },
                            {
                                "completed_by":"James Irmen",
                                "time":"6/1/2019 at 1:22 pm",
                                "incident":"Broken",
                                "reason":"Overuse, old",
                            },
                            {
                                "completed_by":"James Irmen",
                                "time":"6/1/2019 at 11:33 am",
                                "incident":"Broken",
                                "reason":"Overuse, old",
                            },
                            {
                                "completed_by":"Brian Johnson",
                                "time":"6/1/2019 at 8:42 am",
                                "incident":"Lost",
                                "reason":"Had to go to the bathroom, don't know where I left",
                            },
                        ]

                        this.loading = false
                        this.user_ids = []
                        
                        break;
                    case "5":
                        this.gridColumns = ['completed by', 'date time', 'change']

                        this.tableData = [
                            {
                                "completed_by":"Brian Johnson",
                                "time":"6/1/2019 at 10:20 am",
                                "change":"Check In",
                            },
                            {
                                "completed_by":"David Smith",
                                "time":"6/1/2019 at 10:17 am",
                                "change":"Check In",
                            },
                            {
                                "completed_by":"James Irmen",
                                "time":"6/1/2019 at 10:00 am",
                                "change":"Transfer: James Irmen -> David Smith",
                            },
                            {
                                "completed_by":"James Irmen",
                                "time":"6/1/2019 at 9:33 am",
                                "change":"Check Out",
                            },
                            {
                                "completed_by":"Brian Johnson",
                                "time":"6/1/2019 at 8:42 am",
                                "change":"Check Out",
                            },
                            {
                                "completed_by":"James Irmen",
                                "time":"6/1/2019 at 8:05 am",
                                "change":"Name: @" + this.write_asset.name + " -> " + this.write_asset.name,
                            },
                        ]

                        this.loading = false
                        this.user_ids = []
                        
                        break;                    
                    case "6":
                        this.gridColumns = ['asset', 'date time', 'change']

                        this.write_user = this.write_users[0].name

                        this.tableData = [
                            {
                                "asset":"3/32-Inch Drill Bits",
                                "time":"6/1/2019 at 10:17 am",
                                "change":"Check In",
                            },
                            {
                                "asset":"Hammer",
                                "time":"6/1/2019 at 10:00 am",
                                "change":"Transfer: " + this.write_users[0].name + " -> David Smith",
                            },
                            {
                                "asset": "Hammer",
                                "time":"6/1/2019 at 9:33 am",
                                "change":"Check Out",
                            },
                            {
                                "asset":"3/32-Inch Drill Bits",
                                "time":"6/1/2019 at 8:42 am",
                                "change":"Check Out",
                            },
                            {
                                "asset":"Hammer",
                                "time":"6/1/2019 at 8:05 am",
                                "change":"Name: @Hammer -> Hammer",
                            },
                        ]

                        this.loading = false
                        this.user_ids = []
                        
                        break;
                    case "7":
                        this.gridColumns = ['name', 'groups', 'total', 'allocated', 'location']

                        /*var orgId = this.$store.state.usermain.curOrg.id;

                        var collection = database.getFireStoreColl('orgs/' + orgId + '/assets/');

                        collection.get().then(function(querySnapshot) {
                            let _assets = {}

                            querySnapshot.forEach(doc => {
                            console.log(doc.data())
                            
                            _assets.add(doc.data())
                            });

                            self.assets = _assets;

                            this.loading = false
                            this.user_ids = []
                        });*/

                        this.tableData = this.assets.filter((asset) => {
                            if (this.write_datafield['.key'] == "6orf3N149UPSpJDrPXDs") {
                                return asset.groups.includes(this.dataFieldValue)
                            } else if (this.write_datafield['.key'] == "ViB5zETGIqN2nt2sU5um") {
                                return asset.location.includes(this.dataFieldValue)
                            }
                        });

                        this.loading = false
                        this.user_ids = []

                        break;
                }
                this.ran = true
            },
        }
    }
</script>

<style scoped>
    .half {
        height: 25px;
    }
    .timepicker {
        border:1px solid #d9d9d9; 
        display: block; 
        padding: 5px; 
        border-radius: 4px;
    }
    .btn {
        float: right;
    }
    .loading {
        float: center;
    }
</style>





// WEBPACK FOOTER //
// DataFilter.vue?514ce36d